
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-r from-amber-500 to-orange-500 rounded-full">
                <i className="ri-leaf-line text-white text-2xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                  한의사 방앗간
                </h3>
                <p className="text-gray-400">노원장 하이엔드 참기름 &amp; 들기름</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              20년간 한의학을 통해 건강을 연구해온 노태균 원장이 
              직접 만든 프리미엄 기름입니다. 최고의 품질과 건강을 
              동시에 만족시키는 특별한 제품을 제공합니다.
            </p>
            <div className="flex space-x-4">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-500 rounded-full cursor-pointer hover:bg-amber-600 transition-colors">
                <i className="ri-phone-line text-white"></i>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-amber-500 rounded-full cursor-pointer hover:bg-amber-600 transition-colors">
                <i className="ri-mail-line text-white"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">제품 정보</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">참기름</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">들기름</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">가격안내</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">배송정보</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6">고객 지원</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">주문방법</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">품질보증</a></li>
              <li><a href="#" className="text-gray-300 hover:text-white cursor-pointer">교환/환불</a></li>
              <li><a href="tel:010-6607-5556" className="text-gray-300 hover:text-white cursor-pointer">문의전화</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 mb-4 md:mb-0">
              <p>&copy; 2005 노원장 하이엔드 오일</p>
              <p className="text-sm mt-1">라인메디컬. 한의사방앗간 All rights reserved.</p>
              <p className="text-sm mt-1">대표: 노태균 | 연락처: 010-6607-5556</p>
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-white cursor-pointer">개인정보처리방침</a>
              <a href="#" className="text-gray-400 hover:text-white cursor-pointer">이용약관</a>
              <a href="https://readdy.ai/?origin=logo" className="text-amber-500 hover:text-amber-400 cursor-pointer">Dr.ROH</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
